import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
// import MenuBarMenu from './menu-bar-menu.jsx';
// import {MenuItem, MenuSection} from '../menu/menu.jsx';
// import PythonMode from '../../containers/python-mode.jsx';
// import DeletionRestorer from '../../containers/deletion-restorer.jsx';
// import TurboMode from '../containers/turbo-mode.jsx';
import toolsIcon from './tools-icon.svg';
import toolsIconSelected from './tools-icon-selected.svg';
// import styles from "./file-menu-item.css";
import "./menu-bar.css";
import PropTypes from 'prop-types';
import {toast} from 'react-hot-toast';
// import {message} from 'antd';

// 新建文件类组件
class ToolboxMenuItem extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleMouseEnter',
            'handleMouseLeaveOuter',
            'handleMouseLeave',
            'handleToolbox'
        ]);
        this.ref = React.createRef();
        this.state = {
            toolboxState: false
        }
        this.timer = null
    }

    componentDidMount () {
        if (!('ontouchstart' in window)) {
            this.ref.current.addEventListener(
                'mouseenter',
                this.props.onClickEdit
            );
            this.ref.current.addEventListener(
                'mouseleave',
                this.props.onRequestCloseEdit
            );
        }
    }

    componentWillUnmount () {
        this.ref.current.removeEventListener(
            'mouseenter',
            this.props.onClickEdit
        );
        this.ref.current.removeEventListener(
            'mouseleave',
            this.props.onRequestCloseEdit
        );
    }
    // 点击工具箱
    handleToolbox (type) {
        localStorage.setItem('routerMeunId', type)
        window.location.href = window.location.origin
    }
    handleMouseEnter () {
        clearTimeout(this.timer);
        this.setState({
            toolboxState: true
        })
    }
    handleMouseLeaveOuter () {
        this.timer = setTimeout(() => {
            this.setState({
                toolboxState: false
            })
        }, 200);
    }
    handleMouseLeave () {
        this.setState({
            toolboxState: false
        })
    }
    render () {
        return (
            <div>
                <div
                ref={this.ref}
                className={this.state.toolboxState ? 'menuBarItemSelect' : 'menuBarItem'}
            >
                <div
                    style={{display: 'flex'}}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeaveOuter}
                >
                    <img
                        className='menuIcon'
                        src={
                            this.state.toolboxState ?
                                toolsIconSelected :
                                toolsIcon
                        }
                        alt="tools"
                    />
                    <span
                        style={{
                            verticalAlign: 'middle',
                            ...(this.state.toolboxState ?
                                {color: '#3073ff'} :
                                {})
                        }}
                    >
                        {/* 工具箱 */}
                        <FormattedMessage
                            defaultMessage="Toolbox"
                            id="meun-item-toolbox"
                        />
                    </span>
                </div>
            </div>
            {this.state.toolboxState && 
                <div 
                    className="toolboxMenuContainer"
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                >
                    <div
                        className="languageMenuItem"
                        onClick={() => this.handleToolbox('checkUpdate')}
                    >
                        <div className="line"></div>
                        {/* 固件升级 */}
                        <FormattedMessage
                            defaultMessage="Firmware update"
                            id="meun-item-toolbox-checkUpdate"
                        />
                    </div>
                    {/* 校准工具 */}
                    {/* <div
                        className="languageMenuItem"
                        onClick={() => this.handleToolbox('calibration')}
                    >
                        <div className="line"></div>
                        <FormattedMessage
                            defaultMessage="Calibration Tools"
                            id="meun-item-toolbox-calibration"
                        />
                    </div> */}
                    <div
                        className="languageMenuItem"
                        onClick={() => this.handleToolbox('restoreSetting')}
                    >
                        <div className="line"></div>
                        {/* 恢复出厂设置 */}
                        <FormattedMessage
                            defaultMessage="Restore Setting"
                            id="meun-item-toolbox-restoreSetting"
                        />
                    </div>
                    {/* 机器学习 */}
                    {/* <div
                        className="languageMenuItem"
                        onClick={() => this.handleToolbox('machinelearning')}
                    >
                        <div className="line"></div>
                        <FormattedMessage
                            defaultMessage="Machine learning"
                            id="meun-item-toolbox-machinelearning"
                        />
                    </div> */}
                    <div
                        className="languageMenuItem"
                        onClick={() => this.handleToolbox('otherDownload')}
                    >
                        <div className="line"></div>
                        {/* 应用下载 */}
                        <FormattedMessage
                            defaultMessage="Application downloads"
                            id="meun-item-toolbox-otherDownload"
                        />
                    </div>
                    {/* matataChat授权码 */}
                    {/* <div
                        className="languageMenuItem"
                        onClick={() => this.handleToolbox('matataChatCode')}
                    >
                        <div className="line"></div>
                        <FormattedMessage
                            defaultMessage="Authorization Code"
                            id="meun-item-toolbox-matataChatCode"
                        />
                    </div> */}
                </div>
            }
            </div>
            
        );
    }
}

export default ToolboxMenuItem;
